import React, {Component} from 'react';
import Action from 'components/organisms/used-players-list/actions';
import Const from 'constants';
import {rangeOfNumbers} from 'helpers/array-helper';
import InputRadio from 'components/atoms/inputs/input-radio';

class BaseFilterComponent extends Component {
    onChange(value) {
        this.props.dispatch(Action.set('FilterTier', value));
    }

    prepareTabs() {
        const {filters, slate} = this.props;
        const numbers = rangeOfNumbers(1, slate.tiers_quantity);

        const tabs = [
            <label className="tabs-chk" key={Const.PLAYERS_TIERS_FILTER_ALL}>
                <InputRadio
                    value={Const.PLAYERS_TIERS_FILTER_ALL}
                    checked={Const.PLAYERS_TIERS_FILTER_ALL === filters.tier}
                    onChange={::this.onChange}
                />
                <span>All</span>
            </label>,
        ];

        numbers.map((number) => {
            tabs.push(
                <label className="tabs-chk" key={number}>
                    <InputRadio value={number} checked={number === filters.tier} onChange={::this.onChange} />
                    <span>T{number}</span>
                </label>,
            );
        });

        return tabs;
    }
}

export {BaseFilterComponent};
